import type {RequestConfig} from '@Components/ai-chat-window/ai-chat-window.types';
import {ChangeStyleTheme} from '@Components/ai-chat-window/ai-chat-window.types';
import type {ChangeStyleThemeOption} from '@Components/ai-chat-window/components/change-style-dropdown/change-style-dropdown.types';
import {getAssetUrl} from '@Utils/s3.util';

const CHANGE_STYLE_THEME_IMAGE: Record<ChangeStyleTheme, string> = {
  [ChangeStyleTheme.MINIMALIST]: getAssetUrl('ai-chat-change-style-minimalist.webp'),
  [ChangeStyleTheme.EDITORIAL]: getAssetUrl('ai-chat-change-style-editorial.webp'),
  [ChangeStyleTheme.PROFESSIONAL]: getAssetUrl('ai-chat-change-style-professional.webp'),
  [ChangeStyleTheme.VIBRANT_COLOURFUL]: getAssetUrl('ai-chat-change-style-vibrant.webp?ts=2'),
  [ChangeStyleTheme.LUXURY_ELEGANT]: getAssetUrl('ai-chat-change-style-elegant.webp'),
  [ChangeStyleTheme.BOLD_MODERN]: getAssetUrl('ai-chat-change-style-modern.webp'),
  [ChangeStyleTheme.NEON_FUTURISTIC]: getAssetUrl('ai-chat-change-style-neon.webp'),
  [ChangeStyleTheme.PAPERCUT_STYLE]: getAssetUrl('ai-chat-change-style-papercut.webp'),
  [ChangeStyleTheme.WATERCOLOR_SOFT]: getAssetUrl('ai-chat-change-style-watercolor.webp'),
  [ChangeStyleTheme.SOFTCLAY]: getAssetUrl('ai-chat-change-style-softclay.webp?ts=2'),
  [ChangeStyleTheme.HAND_DRAWN]: getAssetUrl('ai-chat-change-style-hand-drawn.webp'),
};

const CHANGE_STYLE_THEME_LABEL: Record<ChangeStyleTheme, string> = {
  [ChangeStyleTheme.MINIMALIST]: 'pmwjs_ai_chat_change_style_theme_minimalist',
  [ChangeStyleTheme.EDITORIAL]: 'pmwjs_ai_chat_change_style_theme_editorial',
  [ChangeStyleTheme.PROFESSIONAL]: 'pmwjs_professional',
  [ChangeStyleTheme.VIBRANT_COLOURFUL]: 'pmwjs_vibrant',
  [ChangeStyleTheme.LUXURY_ELEGANT]: 'pmwjs_elegant',
  [ChangeStyleTheme.BOLD_MODERN]: 'pmwjs_modern_style',
  [ChangeStyleTheme.NEON_FUTURISTIC]: 'pmwjs_ai_chat_change_style_theme_neon',
  [ChangeStyleTheme.PAPERCUT_STYLE]: 'pmwjs_ai_chat_change_style_theme_papercut',
  [ChangeStyleTheme.WATERCOLOR_SOFT]: 'pmwjs_ai_chat_change_style_theme_watercolor',
  [ChangeStyleTheme.SOFTCLAY]: 'pmwjs_ai_chat_change_style_theme_softclay',
  [ChangeStyleTheme.HAND_DRAWN]: 'pmwjs_hand_drawn',
};

const CHANGE_STYLE_THEME_PROMPT: Record<ChangeStyleTheme, string> = {
  [ChangeStyleTheme.MINIMALIST]: 'pmwjs_change_style_to_minimalist',
  [ChangeStyleTheme.EDITORIAL]: 'pmwjs_change_style_to_editorial',
  [ChangeStyleTheme.PROFESSIONAL]: 'pmwjs_change_style_to_professional',
  [ChangeStyleTheme.VIBRANT_COLOURFUL]: 'pmwjs_change_style_to_vibrant',
  [ChangeStyleTheme.LUXURY_ELEGANT]: 'pmwjs_change_style_to_elegant',
  [ChangeStyleTheme.BOLD_MODERN]: 'pmwjs_change_style_to_modern',
  [ChangeStyleTheme.NEON_FUTURISTIC]: 'pmwjs_change_style_to_neon',
  [ChangeStyleTheme.PAPERCUT_STYLE]: 'pmwjs_change_style_to_papercut',
  [ChangeStyleTheme.WATERCOLOR_SOFT]: 'pmwjs_change_style_to_watercolor',
  [ChangeStyleTheme.SOFTCLAY]: 'pmwjs_change_style_to_softclay',
  [ChangeStyleTheme.HAND_DRAWN]: 'pmwjs_change_style_to_hand_drawn',
};

export function getChangeStyleThemePrompt(theme: ChangeStyleTheme): string {
  return window.i18next.t(CHANGE_STYLE_THEME_PROMPT[theme]);
}

export const CHANGE_STYLE_THEME_OPTIONS: ChangeStyleThemeOption[] = [
  ChangeStyleTheme.MINIMALIST,
  ChangeStyleTheme.EDITORIAL,
  ChangeStyleTheme.PROFESSIONAL,
  ChangeStyleTheme.VIBRANT_COLOURFUL,
  ChangeStyleTheme.LUXURY_ELEGANT,
  ChangeStyleTheme.BOLD_MODERN,
  ChangeStyleTheme.NEON_FUTURISTIC,
  ChangeStyleTheme.PAPERCUT_STYLE,
  ChangeStyleTheme.WATERCOLOR_SOFT,
  ChangeStyleTheme.SOFTCLAY,
  ChangeStyleTheme.HAND_DRAWN,
].map((theme) => ({
  theme,
  label: CHANGE_STYLE_THEME_LABEL[theme],
  imageUrl: CHANGE_STYLE_THEME_IMAGE[theme],
}));

export function buildChangeStyleRequestConfig(theme: ChangeStyleTheme): RequestConfig {
  return {
    changeStyleTheme: theme,
  };
}
